<template>
  <div class="basic-info">
    <div class="info settings-container">
    <select v-model="selected" name="language">
      <option v-for="option in langOpts" :key=option[1] :value=option[1] :selected=selected>
        {{ option[0] }}
      </option>
    </select>
    </div>
    <!-- See, I'm using at least ONE webp image -->
    <picture>
      <source srcset="../assets/sbmckay.webp" type="image/webp">
      <img src="../assets/sbmckay.png" alt="Scott McKay of Montana">
    </picture>
    <div class="info content-container">
      <div class="titles">
        <div class="colors">
          <div class="yellow"></div>
          <div class="blue"></div>
        </div>
        <h1 class="name" id="name">{{ resume.basics.name }}</h1>
        <h3>{{ resume.basics.label[selected] }}</h3>
      </div>
      <div class="icons">
        <a href="https://gitlab.com/Evilscaught" rel=noopener target=_blank>
          <svg class="icon icon-gitlab">
            <use xlink:href="#icon-gitlab"></use>
          </svg>
          GitLab
        </a>
        <a href="https://github.com/Evilscaught" rel=noopener target=_blank>
          <svg class="icon icon-github">
            <use xlink:href="#icon-github"></use>
          </svg>
          GitHub
        </a>
        <a v-bind:href="`https://${selected === 'fr' ? 'fr' : 'www'}.linkedin.com/in/scott-burnett-mckay`" rel=noopener target=_blank>
          <svg class="icon icon-linkedin">
            <use xlink:href="#icon-linkedin"></use>
          </svg>
          LinkedIn
        </a>
      </div>
      <p id="text-container" class="text-container"></p>
    </div>
  </div>
</template>

<script>
const languageMap = {
  en: {
    English: 'en',
    French: 'fr'
  },
  fr: {
    Anglais: 'en',
    Français: 'fr'
  }
}

export default {
  name: 'basic-info',
  props: ['resume'],
  data: function () {
    return {
      langOpts: Object.entries(languageMap[this.$router.history.current.params.lang || 'en']),
      selected: this.$router.history.current.params.lang || 'en'
    }
  },
  watch: {
    selected: 'changeLanguage'
  },
  methods: {
    changeLanguage: function (event) {
      this.$router.push({ name: 'home', params: { lang: this.selected } })
      localStorage.setItem('lang', this.selected)

      document.getElementById('text-container').innerHTML = this.resume.basics.summary[this.selected]
    }
  },
  mounted () {
    document.getElementById('text-container').innerHTML = this.resume.basics.summary[this.selected]
  }
}
</script>

<style scoped lang="postcss">
@import 'shared/style-base';

.basic-info {
  --blockHeight: 15rem;
  --blockDesktopHeight: 17rem;

  @mixin basicTags;

  display: flex;
  flex-flow: column;
  padding: var(--spacingMd) 0;
  background-color: var(--colorLightGrey);

  & .titles {
    position: relative;
    text-align: center;
    z-index: 1;

    & .colors {
      width: 75vw;
      height: calc(var(--blockHeight) + calc(var(--blockHeight) / 2));
      margin: 0 auto;

      @media (--desktop) {
        height: calc(var(--blockDesktopHeight) + calc(var(--blockDesktopHeight) / 2));
      }

      @media all and (max-width: 1000px){
        height: 0px;
      }

      & .blue {
        position: absolute;
        border-radius: 10px;
        top: calc(var(--blockHeight) / 2);;
        right: 20rem;
        width: 50vw;
        height: var(--blockHeight);
        background-color: var(--colorPrimary);
        mix-blend-mode: multiply;
        transform: skewY(-6deg);

        @media (--desktop) {
          width: 100%;
          height: var(--blockDesktopHeight);
        }

        @media all and (max-width: 1000px) {
          display: none;
        }
      }

      & .yellow {
        position: absolute;
        width: 50vw;
        border-radius: 10px;
        height: var(--blockHeight);
        top: calc(var(--blockHeight) / 2);
        background-color: var(--colorAccent);
        left: 20rem;
        transform: skewY(6deg);

        @media (--desktop) {
          width: 100%;
          height: var(--blockDesktopHeight);
          top: calc(var(--blockDesktopHeight) / 2);
        }

        @media all and (max-width: 1000px) {
          display: none;
        }
      }
    }

    & h1 {
      position: absolute;
      top: 8rem;
      right: var(--spacingMd);
      margin: 0;
      color: var(--colorLightGrey);

      @media (--desktop) {
        width: 100%;
        text-align: center;
        left: 0;
      }

      @media all and (max-width: 1000px) {
        position: static;
        padding-bottom: 10rem;
        color: var(--colorBlack)
      }
    }

    & h3 {
      position: absolute;
      margin: 0;
      bottom: 6rem;
      left: var(--spacingMd);
      color: var(--colorLightGrey);

      @media (--desktop) {
        width: 100%;
        text-align: center;
        left: 0;
      }

      @media all and (max-width: 1000px) {
        position: static;
        color: var(--colorBlack)
      }
    }
  }

  & .icons {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: var(--spacingMd) 0;
    padding-bottom: 0;

    & a {
      @mixin header6;

      margin: 0;
      text-decoration: none;

      & svg {
        display: block;
        margin: 0 auto;
        width: 4rem;
        height: 4rem;
        fill: var(--colorDarkGrey);
        stroke-width: 0.05rem;
        stroke: var(--colorBlack);
        stroke-dasharray: 200;
        stroke-dashoffset: 200;
        cursor: pointer;
        transition: fill 0.3s ease, stroke-dashoffset 1s ease;
      }

      & div {
      }

      &:hover {
        & svg {
          fill: var(--colorAccent);
          stroke-dashoffset: 0;
        }

        & div {
          color: var(--colorAccent);
        }
      }
    }

  }

  & picture,
  & img {
    text-align: center;
    display: inline-block;
    width: 100%;
    height: auto;
    max-width: 45rem;
    margin: 0 auto;
  }

  & .info {
    text-align: center;
  }

  & .text-container {
    position: relative;
    padding: var(--spacingMd) 0;
  }

  & p {
    text-align: justify;
    border-color: pink;
  }

  select {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: 700;
    width: 120px;
    padding: 0.7rem 0.8rem;
    border: 1px solid transparent;
    border-color: black black black black;
    border-radius: 10px;
    background-color: #e8e8e8;
    user-select: none;

    &:hover {
      color: #6a82c2;
      border-color: #6a82c2;
      transition: border, color 130ms linear;
      cursor: pointer;
    }
  }
}
</style>
